module.exports = __webpack_public_path__ + "img/guangxi.094fdbf7.png";